import { render } from "./Main.vue?vue&type=template&id=6b3af53e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=6b3af53e&lang=less&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=6b3af53e&lang=less"
script.render = render
script.__scopeId = "data-v-6b3af53e"

export default script